const toggleDropdown = () => {
	const toggles = document.querySelectorAll('.dropdown__toggle');
	if (toggles.length > 0) {
		const dropDownLists = document.querySelectorAll('.dropdown__list');
		
		toggles.forEach((toggle) => {
			toggle.addEventListener('click', (evt) => {
				evt.stopPropagation();
				toggle.nextElementSibling.classList.toggle('dropdown__list--active');
				toggle.classList.toggle('dropdown__toggle--active');
			});
		});
		
		dropDownLists.forEach((list) => {
			list.addEventListener('click', (evt) => {
				evt.stopPropagation();
			});
		});
		
		document.addEventListener('click', () => {
			const activeToggles = document.querySelectorAll('.dropdown__toggle--active');
			const activeLists = document.querySelectorAll('.dropdown__list--active');
			
			activeToggles.forEach((activeToggle, index) => {
				activeToggle.classList.remove('dropdown__toggle--active');
				activeLists[index].classList.remove('dropdown__list--active');
			});
			
		});
	}
}

export default toggleDropdown;
